import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IParatikaPosInsatallment } from '../models/models'

export class UpdateParatikaPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParatika/updateParatikaPosInsatallment',
      requesterInfo,
    })
  }

  public async updateParatikaPosInsatallment(request: IParatikaPosInsatallment): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}

